
import React from 'react';
import { formatDistanceToNow } from 'date-fns';

interface ContentFreshnessProps {
  lastUpdated: string;
  playCount?: number;
  isNew?: boolean;
  isTrending?: boolean;
}

const ContentFreshness: React.FC<ContentFreshnessProps> = ({
  lastUpdated,
  playCount,
  isNew,
  isTrending
}) => {
  const timeAgo = formatDistanceToNow(new Date(lastUpdated), { addSuffix: true });
  
  return (
    <div className="flex items-center gap-2 text-sm text-gray-500">
      <span>Updated {timeAgo}</span>
      {playCount && playCount > 0 && (
        <span className="text-blue-600 font-medium">
          • {playCount.toLocaleString()}+ plays
        </span>
      )}
      {isNew && (
        <span className="bg-green-100 text-green-800 px-2 py-1 rounded-full text-xs font-medium">
          NEW
        </span>
      )}
      {isTrending && (
        <span className="bg-red-100 text-red-800 px-2 py-1 rounded-full text-xs font-medium">
          🔥 TRENDING
        </span>
      )}
    </div>
  );
};

export default ContentFreshness;
